import { SecondhandTaxesLandingPageSection } from '../../constants'

export const getIntroductionSectionContent = () => ({
  componentId: SecondhandTaxesLandingPageSection.Introduction,
  testId: 'no-changes-to-taxes--introduction-section',
  text: {
    title: 'secondhand_taxes.introduction.title',
    description: 'secondhand_taxes.introduction.description',
    buttonCta: 'secondhand_taxes.introduction.listing_cta',
  },
})
